<button class="easy-button" (click)="handleclick()">
    <div class="easy-card">
        <div class="first-row">
            <img src="{{ icon }}" alt="heart" width="100" height="100" draggable="false">
        </div>
        <div class="second-row">
            <h3 class="title">{{ title }}</h3>
            <p class="content">{{ content }}</p>
        </div>
    </div>
</button>